<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  analytics: {
    type: Object,
    default: null,
  },
});

const { t } = useI18n();

// `sending`, `send_ambiguous`, `delivery_failed` (P0 hardening pass): a
// send_ambiguous recipient must stay visible after a worker crash rather
// than silently disappearing from this summary - it is deliberately listed
// here as its own row, distinct from `failed`, never auto-retried.
const STATUS_ORDER = [
  'pending',
  'queued',
  'sending',
  'sent',
  'delivered',
  'read',
  'failed',
  'send_ambiguous',
  'delivery_failed',
  'skipped',
];

const totalRecipients = computed(
  () => props.analytics?.audience_snapshot_count || 0
);

const counts = computed(() => props.analytics?.status_counts || {});

const percentage = count => {
  if (!totalRecipients.value) return 0;
  return Math.round(((count || 0) / totalRecipients.value) * 100);
};
</script>

<template>
  <div class="flex flex-col gap-3">
    <h4 class="text-sm font-medium text-n-slate-12">
      {{ t('CAMPAIGN.WHATSAPP.DETAIL.ANALYTICS.TITLE') }}
    </h4>
    <p class="text-xs text-n-slate-11">
      {{
        t('CAMPAIGN.WHATSAPP.DETAIL.ANALYTICS.TOTAL_RECIPIENTS', {
          count: totalRecipients,
        })
      }}
    </p>
    <div class="flex flex-col gap-2">
      <div
        v-for="status in STATUS_ORDER"
        :key="status"
        class="flex items-center gap-3"
      >
        <span class="w-24 text-xs capitalize text-n-slate-11">
          {{ t(`CAMPAIGN.WHATSAPP.DETAIL.STATUS.${status.toUpperCase()}`) }}
        </span>
        <div class="flex-1 h-2 overflow-hidden rounded-full bg-n-alpha-1">
          <div
            class="h-full rounded-full bg-n-blue-9"
            :style="{ width: `${percentage(counts[status])}%` }"
          />
        </div>
        <span class="w-10 text-xs text-end text-n-slate-12">
          {{ counts[status] || 0 }}
        </span>
      </div>
    </div>
  </div>
</template>
